module.exports = __webpack_public_path__ + "img/guowei.cb022c54.png";